import { Box, useMediaQuery, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import ContentfulButton from '../../ContentfulButton';
import { IDescription } from '../ProductFeature.type';
import { buttonBoxStyles, descriptionWrapperStyles } from './Description.styles';
import ContentTypeRichText from '@shared-components/components/ContentTypeRichText';
import { responsiveResolveTypographyVariantStyles } from '@utils/resolveTypographyVariantStyles';
export default function Description({
  descriptionRichText,
  descriptionButton,
  descriptionButtonsCollection
}: Readonly<IDescription>) {
  const theme = useTheme();
  const isSmall: boolean = useMediaQuery(theme.breakpoints.down('md'));
  let descriptionActions: ReactNode = null;
  if (descriptionButtonsCollection) {
    descriptionActions = descriptionButtonsCollection.items.map(button => button && <ContentfulButton key={button.sys.id} {...button} isSmallScreen={isSmall} dataTestId={`product_feature_description_button`} />);
  } else if (descriptionButton) {
    descriptionActions = <ContentfulButton {...descriptionButton} isSmallScreen={isSmall} dataTestId="product_feature_description_button" />;
  }
  return <Box data-testid="product_feature_description" sx={{
    ...descriptionWrapperStyles(theme)
  }} data-sentry-element="Box" data-sentry-component="Description" data-sentry-source-file="Description.tsx">
			{<ContentTypeRichText content={descriptionRichText.content} dataTestId="product_description_Rich_Text" contentMaxWidth="100%" backgroundColor="transparent" disableGutters disablePaddingOn={['Top', 'Bottom']} docProps={{
      sx: responsiveResolveTypographyVariantStyles(theme, 'bodyMediumBook', 'bodyLargeBook')
    }} />}
			<Box sx={buttonBoxStyles} data-sentry-element="Box" data-sentry-source-file="Description.tsx">{descriptionActions}</Box>
		</Box>;
}